import React from "react";
import { Badge, Table, Tabs, Input } from "antd";
import { TABS } from "../lib/useFlightBookings";
import { makeColumns } from "./bookingColumns";

const BookingsTable = ({
  activeTab,
  setActiveTab,
  page,
  setPage,
  pageSize,
  searchInput,
  setSearchInput,
  data,
  loading,
  summary,
  canCancel,
  onView,
  onIssue,
  onCancel,
}) => {
  const columns = makeColumns({ canCancel, onView, onIssue, onCancel });

  const items = TABS.map((tab) => ({
    key: tab.key,
    label: (
      <Badge count={summary?.[tab.summaryKey] ?? 0} overflowCount={999} offset={[12, 0]}>
        <span>{tab.label}</span>
      </Badge>
    ),
  }));

  return (
    <div className="listContainer">
      <div className="listTitle">Flights</div>

      <Tabs activeKey={activeTab} onChange={setActiveTab} items={items} />

      <Input
        className="pageSearch"
        placeholder="Search for flights by Tramango ID or ref number"
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        allowClear
      />

      <Table
        rowKey="_id"
        columns={columns}
        dataSource={data?.bookings}
        loading={loading}
        pagination={{
          current: page,
          pageSize,
          total: data?.metadata?.totalBookings ?? 0,
          onChange: setPage,
          showSizeChanger: false,
        }}
      />
    </div>
  );
};

export default BookingsTable;
